<ada-card
	#CustomPropertiesCard
	id="CustomPropertiesCard"
	[collapseEnabled]="true"
	[verticalSpacing]="'Small'"
	width="100%"
>
	<ada-text
		id="CustomPropertiesCardHeader"
		data-container-selector="ada-card-header"
		content="Custom Properties"
	></ada-text>
	<ada-container
		data-container-selector="ada-card-body"
		[colCount]="4"
		verticalSpacing="Medium"
		horizontalSpacing="Medium"
		[padding]="defaultCardPadding"
	>
		<ada-text
			content="Expressions"
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		></ada-text>
		<ada-container
			[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			[colCount]="2"
		>
			<ada-key-value-builder
				#CustomPropertiesInput
				valueType="expression"
				[customCompletionItems]="availableProperties"
				[entries]="currentPropertyObject"
				[bindings]="{
					propertyMap: serverObject$ | async | adaSerializedPropertyMap,
					objectId: (serverObject$ | async)?.objectId
				}"
				[isDisabled]="isDisabled"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
				(entriesChange)="setCurrentPropertyObject($event)"
			></ada-key-value-builder>
		</ada-container>
	</ada-container>
</ada-card>
